/**
 * Gets all initials of a string
 * @category Getters
 * @category String
 */
export function getInitials(word?: string) {
  if (!word) {
    return '';
  }

  const allInitials = word.replace(/\W*(\w)\w*/g, '$1').toUpperCase();

  let initials = allInitials.charAt(0);

  if (allInitials.length > 1) {
    initials += allInitials.charAt(allInitials.length - 1);
  }

  return initials;
}
